<div class="container mt-4">
  <div class="mb-5 sent-email-wrapper">
    <h1 class="mt-5 mb-4">Confirm your email address!</h1>

    <img src="/assets/images/general/sent-email.png"
      class="sent-email-image"
      alt="sent email">

    <div class="mt-3 mb-4 sent-email-content">
      <div>We’ve sent you an email with a confirmation link to activate your account.</div>
      <div>Please follow the instructions in the email to confirm your registration.</div>
    </div>
  </div>
</div>
